import { Stack as MuiStack } from '@mui/material';
import { forwardRef } from 'react';
import { s } from '../../theme/tokens';
import type { SpacingToken } from '../../theme/tokens';
import type { StackProps as MuiStackProps } from '@mui/material/Stack';

export type StackProps = Omit<MuiStackProps, 'spacing'> & {
  gap?: SpacingToken;
  align?: MuiStackProps['alignItems'];
  justify?: MuiStackProps['justifyContent'];
  wrap?: MuiStackProps['flexWrap'];
};

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  (
    {
      gap = 'md',
      align,
      justify,
      wrap,
      alignItems,
      justifyContent,
      flexWrap,
      sx,
      ...rest
    }: StackProps,
    ref,
  ): JSX.Element => (
    <MuiStack
      ref={ref}
      useFlexGap
      alignItems={align ?? alignItems}
      justifyContent={justify ?? justifyContent}
      flexWrap={wrap ?? flexWrap}
      sx={
        [{ gap: s(gap), minWidth: 0 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])].filter(
          Boolean,
        ) as MuiStackProps['sx']
      }
      {...rest}
    />
  ),
);

Stack.displayName = 'Stack';
